import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const argentineCities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'San Miguel de Tucumán', 'Mar del Plata', 'Salta', 'Santa Fe', 'San Juan', 'Resistencia', 'Neuquén', 'Santiago del Estero', 'Corrientes', 'Posadas', 'Bahía Blanca', 'Paraná'];
const argentineNames = ['María González', 'Laura Fernández', 'Carolina Rodríguez', 'Valeria Martínez', 'Andrea López', 'Silvina García', 'Gabriela Pérez', 'Claudia Sánchez', 'Mónica Romero', 'Patricia Díaz', 'Susana Torres', 'Liliana Álvarez', 'Marcela Ruiz', 'Alejandra Castro', 'Beatriz Morales'];
export function PurchasePopup() {
  const [show, setShow] = useState(false);
  const [name, setName] = useState('');
  const [city, setCity] = useState('');
  useEffect(() => {
    const showPopup = () => {
      setName(argentineNames[Math.floor(Math.random() * argentineNames.length)]);
      setCity(argentineCities[Math.floor(Math.random() * argentineCities.length)]);
      setShow(true);
      setTimeout(() => setShow(false), 5000);
    };
    // Show first popup after 5 seconds
    const firstTimeout = setTimeout(showPopup, 5000);
    // Then show every 15-25 seconds
    const interval = setInterval(() => {
      showPopup();
    }, Math.random() * 10000 + 15000);
    return () => {
      clearTimeout(firstTimeout);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-154">
      {show && <motion.div initial={{
      opacity: 0,
      y: 50
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 50
    }} className="fixed bottom-4 left-4 z-50 max-w-sm" data-id="element-155">
          <div className="bg-white rounded-lg shadow-2xl border-2 border-teal-600 p-4" data-id="element-156">
            <div className="flex items-start justify-between mb-2" data-id="element-157">
              <div className="flex items-center gap-2" data-id="element-158">
                <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse" data-id="element-159"></div>
                <span className="text-sm font-semibold text-gray-900" data-id="element-160">
                  Compra reciente
                </span>
              </div>
              <button onClick={() => setShow(false)} className="text-gray-400 hover:text-gray-600" data-id="element-161">
                <X className="w-4 h-4" data-id="element-162" />
              </button>
            </div>
            <p className="text-sm text-gray-700" data-id="element-163">
              <span className="font-semibold" data-id="element-164">{name}</span> de{' '}
              <span className="font-semibold" data-id="element-165">{city}</span> acaba de comprar el
              Megapack Acompañante Pedagógico
            </p>
            <p className="text-xs text-gray-500 mt-2" data-id="element-166">Hace unos momentos</p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}